import React from "react";

export default function GUI_Header(props) {
    return (
      <div>
        <center>
        <h1>{props.title}</h1>
        <br/>
        </center>
        <div style={{ textAlign: 'justify' , fontSize: 20}}>
        {props.desc}
      </div>
      </div>
    );
  }
  